import { extendTheme } from '@chakra-ui/react';
import * as theme from './theme.example';

export default extendTheme(theme);
